module.exports = __webpack_public_path__ + "static/media/kiwi_724_724.737a4532.png";